import React from "react";
import { useTranslate } from "hooks";
import { useProductName } from "stores/product";
import { HeaderTitle } from "./HeaderTitle";

export const ProductConfiguratorHeaderTitle = () => {
  const productName = useProductName();
  const translate = useTranslate();

  return (
    <HeaderTitle
      title={productName ?? ""}
      subtitle={translate.stringOnly("ORDER_CODE")}
    />
  );
};
